import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-more',
    templateUrl: './more.component.html',
    styleUrls: ['./more.component.scss'],
    standalone: false
})
export class MoreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
